import $ from 'jquery';

function get_scroll_pos (val) {
  if (typeof val === 'number') {
    return val;
  } else {
    // assume it's not ajquery object
    return Math.round($(val).offset().top);
  }
};

export function impoliteScrollTo (scroll_el, val, duration, direction, buffer, callback) {
  // if ($('html').has_one_of_classes('disable-scroll', 'hide-scroll')) {
  //   $.impolite_scroll_to(val, duration, callback);
  // } else {
  var scroll_el = $(scroll_el) || $('html, body');
  var events = 'scroll DOMMouseScroll mousewheel'; // mousedown keyup touch
  var buffer_value = buffer || 0;

  // TODO disabling this for now, only scrolling 1px then dies.
  // scroll_el.one(events, function () {
  //   scroll_el.stop();
  // });

  // TODO default for buffer
  var scroll_to = get_scroll_pos(val) - buffer_value;
  var animate = direction === 'left' ? { scrollLeft: scroll_to } : { scrollTop: scroll_to };
  scroll_el.animate(animate, duration, 'swing')
    .promise()
    .then(function () {
      scroll_el.off(events);
      callback && callback();
    });
}



// WEBPACK FOOTER //
// ./assets/j/util/scrolling.js